// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2UPVI","itemTitle":"ClientEmergencyInfo_itemTitle__uqMh3","itemText":"ClientEmergencyInfo_itemText__2j-Rr"};